// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:42:14

export default {
  "id": "pixel-fun-color-by-number",
  "slug": "pixel-fun-color-by-number",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/708fd7486a2543d9aeb2b53e333b123a-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/708fd7486a2543d9aeb2b53e333b123a/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Pixel Fun Color By Number",
      "description": "Pixel Fun - Color By Number is a fun coloring game that lets you bring pixel art to life. With casual number-based instructions, you’ll fill in each pixel square to reveal stunning artwork.Each image is divided into tiny pixels. Each is assigned a number that corresponds to a color. For example, click on the city scene to fill in color and light up the street.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Casual",
        "Simulation"
      ],
      "tags": [
        "arcade",
        "pixel",
        "street"
      ]
    },
    "zh-CN": {
      "title": "像素趣味填色数",
      "description": "像素乐趣 - 数字填色是一款有趣的填色游戏，让你将像素艺术变成现实。通过轻松的数字指令，你将填充每个像素方块，揭示令人惊叹的艺术作品。每张图片都被分割成微小的像素。每个像素都分配了一个与颜色对应的数字。例如，点击城市场景来填充颜色并照亮街道。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "休闲",
        "模拟"
      ],
      "tags": [
        "街机",
        "像素",
        "街头"
      ]
    },
    "zh-TW": {
      "title": "像素趣味填色數字",
      "description": "像素樂趣 - 以數字上色是一款有趣的塗色遊戲，讓你讓像素藝術變得活躍。透過輕鬆的數字式指示，你將填滿每一個像素方格，揭示驚人的藝術作品。每張圖像都被分割成細小的像素。每一個像素都分配了一個與顏色對應的數字。例如，點擊城市場景以填滿顏色並點亮街道。",
      "instructions": "滑鼠點擊或滑動即可遊玩",
      "genres": [
        "隨意",
        "模擬"
      ],
      "tags": [
        "電玩",
        "像素",
        "街機"
      ]
    },
    "zh-HK": {
      "title": "像素趣味填色數字",
      "description": "像素樂趣 - 色彩填數遊戲是一款有趣的填色遊戲，讓你將像素藝術變得活躍。透過輕鬆的數字指示，你將填滿每一個像素方格，揭露驚人的藝術作品。每張圖像都細分為微小的像素。每個像素都分配了一個對應的顏色數字。例如，點擊城市場景來填色並點亮街道。",
      "instructions": "滑鼠點擊或觸控開始遊戲",
      "genres": [
        "輕鬆",
        "模擬"
      ],
      "tags": [
        "街機",
        "像素",
        "街頭"
      ]
    },
    "ja": {
      "title": "ピクセルファン カラバイナンバー",
      "description": "ピクセル・ファン - 数字で塗り絵は、ピクセルアートを生き返らせる楽しい塗り絵ゲームです。カジュアルな数字に基づいた指示で、それぞれのピクセルスquaresを塗り、圧巻のアートワークを明かします。各画像は小さなピクセルに分割されています。それぞれに色に対応する数字が割り当てられています。例えば、都市の風景をクリックして色を塗り、街を明るく照らします。",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "カジュアル",
        "シミュレーション"
      ],
      "tags": [
        "アーケード",
        "ピクセル",
        "ストリート"
      ]
    },
    "ko": {
      "title": "픽셀 펀 색칠하기 숫자로",
      "description": "픽셀 펀 - 숫자로 칠하기는 픽셀 아트를 생생하게 만들어주는 즐거운 칠하기 게임입니다. 캐주얼한 숫자 기반 지시를 통해 각 픽셀 사각형을 채우고, 놀라운 아트워크를 공개할 수 있습니다. 각 이미지는 작은 픽셀로 나누어져 있으며, 각 픽셀은 해당하는 색상과 일치하는 숫자가 할당되어 있습니다. 예를 들어, 도시 풍경을 클릭하여 색상을 채우고 거리를 밝게 만들 수 있습니다.",
      "instructions": "마우스 클릭이나 탭하여 게임 시작",
      "genres": [
        "캐주얼",
        "시뮬레이션"
      ],
      "tags": [
        "아케이드",
        "픽셀",
        "거리"
      ]
    },
    "fr": {
      "title": "Pixel Fun Color by Number",
      "description": "Pixel Fun - Color By Number est un jeu de coloriage amusant qui vous permet de faire vivre l'art pixel. Avec des instructions basées sur des nombres occasionnels, vous remplirez chaque carré de pixel pour révéler des œuvres d'art époustouflantes. Chaque image est divisée en petits pixels. Chaque pixel est assigné un numéro correspondant à une couleur. Par exemple, cliquez sur la scène de ville pour remplir de la couleur et allumer la rue.",
      "instructions": "Clic ou tapotez pour jouer",
      "genres": [
        "Facile",
        "Simulation"
      ],
      "tags": [
        "arcade",
        "pixel",
        "rue"
      ]
    }
  }
};
